import { Component } from '@angular/core';
import { LoginService } from '../../../services/login-service';

@Component({
  selector: 'app-user-registration',
  standalone: false,

  templateUrl: './user-registration.component.html',
  styleUrl: './user-registration.component.css'
})
export class UserRegistrationComponent {

  constructor(private loginService: LoginService) {

  }

  // A pending user has no client yet, so their default application is the only signal for
  // which product they registered against — FracX registrants get the FracX support inbox,
  // everyone else the Well Chron one.
  get supportEmail(): string {
    return this.loginService.userOptional?.defaultApplication === 'FracX'
      ? 'exchangesupport@enverus.com'
      : 'devsupport@pdsenergy.com';
  }
}
